// Alturas, em mm, que a distribuição das páginas precisa saber.
export interface MedidasDaPagina {
  // Altura que sobra para o conteúdo na primeira página, abaixo do cabeçalho, e nas outras.
  primeira: number;
  demais: number;
  // A linha dos dias, que abre a grade em cada página.
  colunas: number;
  linha: number;
  // As linhas de totais, no fim da grade, sempre juntas.
  totais: number;
  // Os quadros abaixo da grade, sempre juntos; 0 quando não há.
  quadros: number;
  // Espaço entre a grade e os quadros.
  respiro: number;
}

export interface PaginaDaImpressao {
  // Colaboradores da página, de inicio até antes de fim.
  inicio: number;
  fim: number;
  // A página tem a grade: a linha dos dias, mais colaboradores ou os totais.
  grade: boolean;
  totais: boolean;
  quadros: boolean;
}

// A impressão monta as próprias páginas (o @page tem margem 0, para o navegador não pôr o
// cabeçalho e o rodapé dele), então o conteúdo é distribuído aqui, um embaixo do outro: cada página
// vai até onde cabe, e os totais e os quadros vêm logo depois do último colaborador, passando para a
// página seguinte só quando não cabem no que sobrou.
export function paginarImpressao(colaboradores: number, m: MedidasDaPagina): PaginaDaImpressao[] {
  const paginas: PaginaDaImpressao[] = [];
  let pagina: PaginaDaImpressao = { inicio: 0, fim: 0, grade: false, totais: false, quadros: false };
  let livre = m.primeira;
  // A folga evita que um 162 / 5,4 de ponto flutuante deixe a última linha de fora.
  const cabe = (altura: number) => altura <= livre + 1e-9;
  const virar = () => {
    paginas.push(pagina);
    pagina = { inicio: pagina.fim, fim: pagina.fim, grade: false, totais: false, quadros: false };
    livre = m.demais;
  };
  // Parte da grade: na página que ainda não a tem, vem junto a linha dos dias.
  const naGrade = (altura: number) => {
    if (!cabe(pagina.grade ? altura : m.colunas + altura)) virar();
    if (!pagina.grade) {
      pagina.grade = true;
      livre -= m.colunas;
    }
    livre -= altura;
  };

  for (let i = 0; i < colaboradores; i++) {
    naGrade(m.linha);
    pagina.fim = i + 1;
  }
  naGrade(m.totais);
  pagina.totais = true;
  if (m.quadros > 0) {
    if (!cabe(m.respiro + m.quadros)) virar();
    pagina.quadros = true;
  }
  paginas.push(pagina);
  return paginas;
}
